import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '../Rebass';

import { AlertProps } from '.';
import Icon from '../Icon';
import theme from '../../theme';

type AlertBannerProps = Omit<
  AlertProps,
  'variant' | 'headline' | 'subtitle' | 'renderImage'
>;

const StyledFlex = styled(Flex)`
  width: 100%;
  border-bottom: 0.5px solid ${theme.colors.baseGray};
`;

const AlertBanner = ({
  children,
  isDismissible,
  onDismiss,
  bg = 'baseBlack',
}: AlertBannerProps) => {
  return (
    <StyledFlex p={[1]} bg={bg} justifyContent="center" alignItems="center">
      <Box mr={[2]} sx={{ maxWidth: '80%', overflowWrap: 'break-word' }}>
        {children}
      </Box>
      {isDismissible && (
        <Box
          data-testid="close-icon"
          sx={{
            cursor: 'pointer',
            position: ['absolute', 'absolute', 'static'],
            top: [1],
            right: [2],
          }}
          onClick={() => onDismiss()}
        >
          <Icon name="close" sx={{ color: 'textWhite' }} />
        </Box>
      )}
    </StyledFlex>
  );
};

export default AlertBanner;
